import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import CheckboxGroup from "./CheckboxGroup";
import _ from "../../../utils/ObjectUtils";

class CheckboxGroupContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allSelected: false,
            fieldsValues: props.values
        }
    }

    handleSelectAllClicked = () => {
        const { values, handleFieldChange } = this.props;
        const { allSelected } = this.state;
        let { fieldsValues } = this.state;

        Object.keys(values).forEach( checkboxLabel => {
            fieldsValues[checkboxLabel] = !allSelected;
        });

        this.setState({
            allSelected: !allSelected,
            fieldsValues: fieldsValues
        }, () => handleFieldChange("checkboxGroupsValues", fieldsValues));
    };

    handleCheckboxClicked = (labelName, value) => {
        const {values, maxChecked, handleFieldChange} = this.props;
        let { fieldsValues, allSelected } = this.state;

        let numberOfCheckboxes =  Object.keys(values).length;
        let checkedBoxesCount = 0;

        if (!_.isNilOrEmpty(values)){
            Object.values(values).forEach( checkboxValue => {
                if (checkboxValue)
                    checkedBoxesCount++;
            });
        }

        let _allSelected = false;
        if (!value) {
                fieldsValues[labelName] = false;
                if (allSelected){
                    _allSelected= false;
                }
        } else if ( _.isNilOrEmpty(maxChecked) || (checkedBoxesCount < maxChecked)) {
            fieldsValues[labelName] = true;
            if ( (checkedBoxesCount + 1 === numberOfCheckboxes) ){
                _allSelected= true;
            }
        }

        this.setState({
            allSelected: _allSelected,
            fieldsValues: fieldsValues
        }, () => handleFieldChange("checkboxGroupsValues", fieldsValues));
    };

    render() {
        const { allSelected } = this.state;
        const { values, maxChecked, title } = this.props;
        let { hasSelectAll } = this.props;

        if(hasSelectAll && (maxChecked < Object.keys(values).length)){
            console.error("Select All will not be available if maxChecked was set.");
            hasSelectAll = false;
        }

        return (
            <CheckboxGroup
                values={values}
                title={title}
                handleCheckboxClicked={this.handleCheckboxClicked}
                handleSelectAllClicked={this.handleSelectAllClicked}
                hasSelectAll={hasSelectAll}
                allSelected={allSelected}
            />
        )
    }
}

CheckboxGroupContainer.propTypes = {
    values: PropTypes.object,
    maxChecked: PropTypes.number,
    hasSelectAll: PropTypes.bool,
    handleFieldChange: PropTypes.func.isRequired,
    title: PropTypes.string
};

export default CheckboxGroupContainer;